import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Users } from './sales.service';

export interface UserComment{

    commentId : number;
    title : String;
    text : String;
    email : String;
    purchaseDatee : string;
    opportunity : {opportunityId : string};
    user: Users;
}

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  constructor(private httpClient:HttpClient) { }

  public getUserComments( oppId : any) {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<UserComment[]>('/api/v1/comments/for/'+ oppId , {headers});
    //.pipe(catchError(this.errorHandler));
  }

  public postComment( data: UserComment){

    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<UserComment>('/api/v1/comments/' , data , {headers}).pipe(catchError(this.errorHandler));

  }
  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
